// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminAuth = (client) => ({
    /**
     * `POST /admin/auth/link-google`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuthLinkGooglePost
     * @source apps/backend/src/api/admin/auth/link-google/route.ts
     */
    updateLinkGoogle: (body, query, headers) => client.fetch("/admin/auth/link-google", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=auth.js.map